function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 3,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(60.784314%,60.784314%,60.784314%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 9.997991 5.498437 L 37.002009 5.498437 C 41.696763 5.498437 45.499777 9.307813 45.499777 14.000223 L 45.499777 35.999107 C 45.499777 40.696652 41.696763 44.500893 37.002009 44.500893 L 9.997991 44.500893 C 5.303237 44.500893 1.500223 40.696652 1.500223 35.999107 L 1.500223 14.000223 C 1.500223 9.307813 5.303237 5.498437 9.997991 5.498437 Z M 9.997991 5.498437 ",
    transform: "matrix(0.744681,0,0,0.76087,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(60.784314%,60.784314%,60.784314%)",
      fillOpacity: 1
    },
    d: "M 1.488281 12.933594 L 33.511719 12.933594 L 33.511719 15.21875 L 1.488281 15.21875 Z M 1.488281 12.933594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(60.784314%,60.784314%,60.784314%)",
      fillOpacity: 1
    },
    d: "M 9.679688 1.140625 L 9.679688 7.226562 C 9.679688 7.859375 9.179688 8.371094 8.5625 8.371094 C 7.945312 8.371094 7.445312 7.859375 7.445312 7.226562 L 7.445312 1.140625 C 7.445312 0.511719 7.945312 0 8.5625 0 C 9.179688 0 9.679688 0.511719 9.679688 1.140625 Z M 9.679688 1.140625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(60.784314%,60.784314%,60.784314%)",
      fillOpacity: 1
    },
    d: "M 27.554688 1.140625 L 27.554688 7.226562 C 27.554688 7.859375 27.054688 8.371094 26.4375 8.371094 C 25.820312 8.371094 25.320312 7.859375 25.320312 7.226562 L 25.320312 1.140625 C 25.320312 0.511719 25.820312 0 26.4375 0 C 27.054688 0 27.554688 0.511719 27.554688 1.140625 Z M 27.554688 1.140625 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.f0eb592ee1a89695d614b3e7e294e8ac.svg";
export { ForwardRef as ReactComponent };